import ApiClient from '../../../../base/api';
import {
    LoginParams,
    PasswordResetParams,
    SignUpParams,
    SignUpResponseParams,
    ValidateSignUpStageParams,
    PasswordSetNewParams,
} from './interfaces';

const apiClient = new ApiClient();

export const authApi = {
    login: (data: LoginParams) => apiClient.post<LoginParams, void>('/api/login ', data),
    validateSignUpStep: (data: ValidateSignUpStageParams) =>
        apiClient.post<ValidateSignUpStageParams, void>('/api/sign-up ', data),
    signUp: (data: SignUpParams) => apiClient.post<SignUpParams, SignUpResponseParams>('/api/sign-up ', data),
    passwordReset: (data: PasswordResetParams) =>
        apiClient.post<PasswordResetParams, void>('/api/password-reset ', data),
    passwordSetNew: (data: PasswordSetNewParams) =>
        apiClient.post<PasswordSetNewParams, void>('/api/password-set ', data),
};
